
















import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";
import OktaFactorSettings from "@/shared/components/OktaFactorSettings.vue";
import { useUserStore } from "@/shared/store/user";
import { Vue, Component } from "@/shared/vuepack";

@Component({
  components: {
    SettingsNavigation,
    OktaFactorSettings
  }
})
export default class Security extends Vue {
  userStore = useUserStore();
}
